(() => {
  const BUY_NOW_AR = 'اشتري الآن';
  const buyNowSelector = 'shopify-buy-it-now-button button, .shopify-payment-button__button--unbranded';
  const moneySelector = '.hdt-money, .hdt-btn-atc_text, [data-money]';

  const localizeBuyNow = (root = document) => {
    const buttons = root.matches?.(buyNowSelector)
      ? [root]
      : root.querySelectorAll?.(buyNowSelector) || [];

    buttons.forEach((button) => {
      const label = button.textContent.trim();
      if (label && label !== BUY_NOW_AR) {
        button.textContent = BUY_NOW_AR;
        button.setAttribute('aria-label', BUY_NOW_AR);
      }
    });
  };

  const removeRepeatedLe = (root = document) => {
    const elements = root.matches?.(moneySelector)
      ? [root]
      : root.querySelectorAll?.(moneySelector) || [];

    elements.forEach((element) => {
      element.childNodes.forEach((node) => {
        if (node.nodeType === Node.TEXT_NODE && /\bLE\s+/i.test(node.textContent)) {
          node.textContent = node.textContent.replace(/\bLE\s+/gi, '');
        }
      });
    });
  };

  const enhance = (root = document) => {
    localizeBuyNow(root);
    removeRepeatedLe(root);
  };

  const start = () => {
    enhance();
    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) enhance(node);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
